import React from 'react';

import { InfoBanner } from '../../common/utils';
const PlanogramImage = ({ imageUrl, t }) => {
  return (
    <div className="planogram__image">
      <InfoBanner message={t('common:planogramImageHelpText')} />
      <img src={imageUrl} alt="planogram-image" />
    </div>
  );
};

export default PlanogramImage;
